function normalizeMeterScoringPrompts(meterScoringPrompts) {
    if (!meterScoringPrompts || Array.isArray(meterScoringPrompts)) {
        return {};
    }
    return meterScoringPrompts;
}
export default function applyMeterScoringPrompt(content, payload) {
    const meterScoringPrompts = normalizeMeterScoringPrompts(content.meterScoringPrompts);
    if (payload.prompt.trim() === '') {
        delete meterScoringPrompts[payload.meterId];
        if (Object.keys(meterScoringPrompts).length === 0) {
            delete content.meterScoringPrompts;
        }
        return;
    }
    meterScoringPrompts[payload.meterId] = {
        prompt: payload.prompt,
        complement: payload.complement,
    };
    content.meterScoringPrompts = meterScoringPrompts;
}
